import { datepickerToDate } from '../../../libs/dates';
import ApplicationController from './application_controller';

/* global $ */
export default class extends ApplicationController {
  connect() {
    this._onChange = this._onChange.bind(this);
    this._onInicioChange = this._onInicioChange.bind(this);
    this._onFinChange = this._onFinChange.bind(this);

    this.selectAlumno = this.element.querySelector('.justificacion-alumno .select-cifra');

    this.inputFechaInicio = this.element.querySelector('[name="justificacion[inicio]"]');
    this.inputFechaFin = this.element.querySelector('[name="justificacion[fin]"]');

    if (this.selectAlumno) {
      this.selectAlumno.addEventListener('change', this._onChange);
    }
    if (this.inputFechaInicio) {
      this.inputFechaInicio.addEventListener('change', this._onInicioChange);
    }
    if (this.inputFechaFin) {
      this.inputFechaFin.addEventListener('change', this._onFinChange);
    }
  }

  disconnect() {
    if (this.selectAlumno) {
      this.selectAlumno.removeEventListener('change', this._onChange);
    }
    if (this.inputFechaInicio) {
      this.inputFechaInicio.removeEventListener('change', this._onInicioChange);
    }
    if (this.inputFechaFin) {
      this.inputFechaFin.removeEventListener('change', this._onFinChange);
    }
  }

  _onChange(event) {
    this._refrescarHorarios(event);
  }

  _onInicioChange() {
    if (this.inputFechaInicio && this.inputFechaFin) {
      this.inputFechaFin.value = this.inputFechaInicio.value;
    }
    this._refrescarHorarios();
  }

  _onFinChange() {
    if (!this.inputFechaInicio || !this.inputFechaFin) return;
    const inicio = datepickerToDate(this.inputFechaInicio.value);
    const fin = datepickerToDate(this.inputFechaFin.value);
    if (fin.getTime() < inicio.getTime()) {
      this.inputFechaInicio.value = this.inputFechaFin.value;
    }
    this._refrescarHorarios();
  }

  _refrescarHorarios(event) {
    const opcion = event?.detail?.value;
    const usuarioId = (opcion?.id ?? this.element.querySelector('input[name="justificacion[usuario_id]"]')?.value) || null;
    const grupoId = opcion?.grupo_id ?? null;
    const inicio = this.inputFechaInicio?.value;
    const fin = this.inputFechaFin?.value;

    $.post('/justificaciones_anticipadas/horarios', {
      inicio,
      fin,
      usuario_id: usuarioId,
      grupo_id: grupoId,
    });
  }
}
